export const CHECK_INTERVAL_TIME_PROCESS = 5000;

export const DEFAULT_OTP_TIMEOUT = 60;

// Version check interval - check for new version every 5 minutes
export const VERSION_CHECK_INTERVAL = 5 * 60 * 1000;
